/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  React,
  Angular,
  NodeJs,
  Firebase,
  Bootstrap,
  Javascript,
  MUI,
  Saas,
  Tailwind,
  Typescript,
  CircleCI,
  Heroku,
  Jira,
  Github2,
  Vercel,
  Bitbucket,
  ReactNative,
  Flutter,
  GraphQL,
  MongoDb,
  Postman,
  Swagger,
  Redux,
  Webpack,
  Figma,
  NextJs,
} from './skills'

import GooglePlay from './portfolio/google-play.svg'

type SkillImages = {
  name: string
  image: any
}

// hero images
const HeroImages = {
  developer: require('./hero/developer.png'),
}

// services card images
const ServiceCardImages = {
  mobile: require('./services/mobile2.png'),
  web: require('./services/web.png'),
  design: require('./services/ui2.png'),
  project: require('./services/project.png'),
}

// about me card images
const AboutMeImages = {
  location: require('./about/location.png'),
  langauges: require('./about/languages.png'),
  degree: require('./about/degree.png'),
  work: require('./about/work.png'),
}

const FrontEndSkills: SkillImages[] = [
  {
    name: 'React',
    image: React,
  },
  // {
  //   name: 'Angular',
  //   image: Angular,
  // },
  {
    name: 'React Native',
    image: ReactNative,
  },
  {
    name: 'Next.js',
    image: NextJs,
  },
  // {
  //   name: 'Flutter',
  //   image: Flutter,
  // },
  {
    name: 'Javascript',
    image: Javascript,
  },
  {
    name: 'Typescript',
    image: Typescript,
  },
  {
    name: 'Redux',
    image: Redux,
  },
  {
    name: 'Webpack',
    image: Webpack,
  },
  {
    name: 'Bootstrap',
    image: Bootstrap,
  },
  {
    name: 'Material UI',
    image: MUI,
  },
  {
    name: 'Saas',
    image: Saas,
  },
  {
    name: 'Tailwind CSS',
    image: Tailwind,
  },
]

const BackEndSkills: SkillImages[] = [
  {
    name: 'Node',
    image: NodeJs,
  },
  {
    name: 'GraphQL',
    image: GraphQL,
  },
  {
    name: 'MongoDB',
    image: MongoDb,
  },
  {
    name: 'Postman',
    image: Postman,
  },
  {
    name: 'Swagger',
    image: Swagger,
  },
]

const OtherSkills: SkillImages[] = [
  {
    name: 'Firebase',
    image: Firebase,
  },
  {
    name: 'Circle CI',
    image: CircleCI,
  },
  {
    name: 'Github',
    image: Github2,
  },
  {
    name: 'Bitbucket',
    image: Bitbucket,
  },
  {
    name: 'Heroku',
    image: Heroku,
  },
  {
    name: 'Vercel',
    image: Vercel,
  },
  {
    name: 'Jira',
    image: Jira,
  },
  {
    name: 'Figma',
    image: Figma,
  },
]

const PortfolioImages = {
  salaryApp: require('./portfolio/salary-app.png'),
  sportApp: require('./portfolio/sports-app.png'),
  cleanLinessApp: require('./portfolio/cleanliness-app.jpeg'),
}

const GooglePlayIcon = GooglePlay

export {
  ServiceCardImages,
  AboutMeImages,
  FrontEndSkills,
  BackEndSkills,
  OtherSkills,
  HeroImages,
  PortfolioImages,
  GooglePlayIcon,
}
